import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiButton, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {ELEVATE_LINK, WEIGHT_LOSS_TWO_KEYS, WEIGHT_LOSS_TWO_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setMedicalUUID} from '~/redux/questionnaires/slice';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {redirectInIframe} from '~/utils/helpers';

interface Props {}

const MDQ2Questionnaire10Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const [redirectLoading, setRedirectLoading] = useState(false);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_TWO_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_TWO_KEYS.THANK_YOU);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_TWO_KEYS.THANK_YOU]?.data,
  );

  const collectedData = mdq.collectedData;

  const onClickSubmit = () => {
    setRedirectLoading(true);
    redirectInIframe(ELEVATE_LINK, '_blank');
  };

  useEffect(() => {
    dispatch(setMedicalUUID({uid: ''}));
  }, [dispatch]);

  return (
    <UiQuestionnaireLayout
      backIcon
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      pageTitle={questionnaire?.title}
    >
      <Col textAlign="center" mt={36} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={6}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText fontSize="sm" fontWeight="400" color="liteOuter" mb={6}>
          {questionnaire?.descriptions?.default}
        </UiText>
        <Col alignItems="center" justifyContent="center" w="100%">
          <UiButton isLoading={redirectLoading} onClick={onClickSubmit} w="55%" variant="primary">
            Return to website
          </UiButton>
        </Col>
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default MDQ2Questionnaire10Screen;
